import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { fetchCustomersapi } from "src/redux/api/_customer.api";
import { Customer } from "src/redux/types/_customer.type";

export interface CustomerFilters {
  state: string;
  district: string;
  email: string;
  name: string;
  employee_name: string;
  employee_code: string;
  fromDate: string;
  toDate: string;
  health_seeker: string;
  page: number;
  pagesize: number;
}

export interface GetCustomersResponse {
  customers: Customer[];
}

export const customerKeys = {
  all: ["admin-customers"] as const,
  list: (filters: CustomerFilters) =>
    [...customerKeys.all, "list", filters] as const,
  update: (customerId: number) => [...customerKeys.all, "update", customerId ] as const,
};

export function useFetchCustomers(filters: CustomerFilters) {
  return useQuery<Customer[], AxiosError>({
    queryKey: customerKeys.list(filters),
    queryFn: () => fetchCustomersapi(filters),
    placeholderData: keepPreviousData, // keeps old rows on screen while the next page loads
    staleTime: 60 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
  });
}
